var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlotProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: 1024,
    height: 1024,
    role: "img",
    "aria-label": "Plot Project",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "card",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF4437"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0130D"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "lift",
    x: "-12%",
    y: "-12%",
    width: "130%",
    height: "135%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 7,
    stdDeviation: 7,
    floodColor: "#6E0A05",
    floodOpacity: 0.3
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "card",
    d: "M0 246.6C0 91.24 91.24 0 246.6 0H777.4C932.76 0 1024 91.24 1024 246.6V777.4C1024 932.76 932.76 1024 777.4 1024H246.6C91.24 1024 0 932.76 0 777.4Z",
    fill: "url(#card)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mark",
    fill: "#fff",
    filter: "url(#lift)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 189.8,
    cy: 219.1,
    r: 41.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.8 219.1V811.8",
    stroke: "#fff",
    strokeWidth: 23.3,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.9,
    y: 304,
    width: 527,
    height: 98,
    rx: 16.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.1,
    y: 457.5,
    width: 207.4,
    height: 98,
    rx: 16.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 456.7,
    y: 610.9,
    width: 176.8,
    height: 98,
    rx: 16.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 715,
    y: 667,
    width: 132.8,
    height: 132.8,
    rx: 9.2,
    transform: "rotate(45 781.4 733.4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlotProject);
export default __webpack_public_path__ + "static/media/plot-project.da1131d488e91f12c199b460611abfd2.svg";
export { ForwardRef as ReactComponent };